/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";
import { 
  Button, 
  Container, 
  Row, 
  Col,
  Card,
  CardBody,
  CardTitle, 
  FormGroup,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { 
  reduxForm,
  getFormValues,
  SubmissionError,
} from "redux-form";
import isEmpty from 'lodash-es/isEmpty';

import Dropzone from "custom-components/Dropzone.jsx";
import FormField from "custom-components/form/FormField";
import CustomInput from "custom-components/form/CustomInput";
import { 
  crudGetOneByMultipart as crudGetOneByMultipartAction,
} from 'store/actions/dataActions';
import { 
  showNotification as showNotificationAction
} from 'store/actions/notificationActions';
import { trimLeft } from 'util/form';
import { 
  DOCUMENT_DEIDENTIFICATION_MAX_FILE_SIZE
} from 'util/constants';
import {
  makeShortenedFilename
} from 'util/common';

class DocumentDeIdentificationHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    // refresh / 분석이 성공했을 때
    if( nextProps.refreshVersion !== this.props.refreshVersion || 
        ( nextProps.item !== this.props.item )
    ) {
      this.props.reset();
      this.dropzone.removeAllFiles();
    }
  }

  // dropzone 
  initDropzone = (dz) => {
    //console.log("DocumentAnalysisHeader - initDropzone");
    this.dropzone = dz;
  }

  addFileAtState = (file, response) => {
    //console.log("file:",file)
    this.props.array.push('files', file);
  }

  removeFileAtState = (file) => {
    //console.log("remove file:",file)

    const formFiles = this.props.formValues.files;
    const files = formFiles.filter( tmpFile  => tmpFile.upload.uuid !== file.upload.uuid )
    if( formFiles.length !== files.length ) {
      this.props.change('files', files);
    }
  }


  render() {
    const handleSubmit = this.props.handleSubmit;
    const { files } = this.props.formValues;
    const filename = files && files.length > 0 && files[0].status !== "error" ? files[0].name : "";
    const shortenedFilename = makeShortenedFilename(filename);

    return (
      <form onSubmit={handleSubmit} autoComplete="off" noValidate>
        <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
          <Container fluid>
            <Row>
              <Col>
                <h1 className="display-2 text-white text-center">SPIKE DA (Docs Anonymizer)</h1>
                <p className="text-white mt-0 text-center">
                  정보를 보호하기 위해 문서의 내용을 비식별화 합니다.<br/>
                  파일을 업로드해서 비식별화된 문서 내용을 확인해보세요.
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="card-stats mt-4 mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-muted mb-0"
                        >
                          파일 업로드
                        </CardTitle>
                        <Dropzone
                          autoProcessQueue={false}
                          maxFiles={1}
                          maxFilesize={DOCUMENT_DEIDENTIFICATION_MAX_FILE_SIZE}
                          acceptedFiles=".docx,.doc,.pptx,.ppt,.xlsx,.xls,.hwp,.pdf"
                          initDropzone={this.initDropzone}
                          addFileAtState={this.addFileAtState}
                          removeFileAtState={this.removeFileAtState}
                        />
                      </div>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success">
                        docx, doc, pptx, ppt, xlsx, xls, hwp, pdf 파일
                      </span>{""}
                      <span className="text-nowrap">을 업로드해보세요.</span>
                    </p>
                    <hr className="my-4" />
                    <h5 className="text-muted">
                      비식별화 정보
                    </h5>
                    <div className="pl-lg-4">
                      <Row>
                        <Col md="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-basic-feature"
                            >
                              기본 비식별화 정보
                            </label>
                            <Input
                              className="form-control-alternative"
                              defaultValue="주민번호, 전화번호, 이메일, 여권번호"
                              id="input-basic-feature"
                              type="text"
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>

                    <div className="pl-lg-4">
                      <Row>
                        <Col md="12">
                          <FormField
                            name="customPattern"
                            component={CustomInput}
                            labelText="사용자 지정 패턴"
                            type="text"
                            inputProps={{ placeholder: "추가적인 비식별 패턴을 입력하세요. 입력하지 않으면 적용되지 않습니다." }}
                            //validate={[required]}
                            normalize={trimLeft}
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="col text-right pr-0">
                      { filename && (
                        <Button
                          color="primary"
                          onClick={this.onSubmit}
                        >
                          {shortenedFilename} 파일의 비식별화를 시작해볼까요?
                        </Button>
                      )}
                    </div>
                  </CardBody>
                </Card>
                </Col>
            </Row>
          </Container>
        </div>
      </form>
    );
  }
}


export default compose(
  connect(
    ( state, props ) => ({
      menu: "DOCUMENT.DEIDENTIFICATION",
      refreshVersion: state.main.refreshVersion,
      item: state.main.item,
      formValues: getFormValues(props.form)(state) || {},
      initialValues: getInitValues(state, props),
      onSubmitValidation: submitValidation,
    }), {
      dispatchCrudGetOneByMultipart: crudGetOneByMultipartAction,
      dispatchShowNotification: showNotificationAction,
    }
  ),
  reduxForm({
    enableReinitialize: true,
    onSubmit: submit,
  })
)(DocumentDeIdentificationHeader);

DocumentDeIdentificationHeader.propTypes = {
  menu: PropTypes.string.isRequired,
};


//************ form 초기값 / validation / submit ************//
function getInitValues(state, props) {
  return {
    files: [],
  }
}

function submitValidation(values, props) {
  const errors = {};
  if( !values.files || values.files.length === 0 ) {
    errors.files = "분석할 파일을 업로드해주세요.";
  }
  if( !isEmpty(errors) ) {
    props.dispatchShowNotification(
      '분석할 파일을 업로드해주세요.',
      'warning'
    );
    throw new SubmissionError( errors );
  }
}

function submit(values, dispatch, props) {
  //console.log("values:", values);
  if( props.onSubmitValidation ) props.onSubmitValidation(values, props);

  let formData = new FormData();
  formData.append("file", values.files[0]);
  if( values.customPattern ) {
    formData.append("customPattern", values.customPattern);
  }
  props.dispatchCrudGetOneByMultipart(props.menu, formData);
}
